(function () {
  'use strict';

  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-timeline]'));
  if (!sections.length) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var track = section.querySelector('[data-timeline-track]');
    var fill = section.querySelector('[data-timeline-fill]');
    var revealEls = Array.prototype.slice.call(section.querySelectorAll('[data-reveal]'));

    /* Reveal each item from the bottom as it enters the viewport */
    if (revealEls.length) {
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealEls.forEach(function (el) {
          el.classList.add('is-visible');
        });
      } else {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
        );
        revealEls.forEach(function (el) {
          observer.observe(el);
        });
      }
    }

    /* Continuous line fill + per-node ring fill that track scroll progress.
       Vertical mode follows the window's vertical scroll; horizontal mode (desktop
       only) follows the track's own horizontal scroll. */
    if (track && fill) {
      var line = section.querySelector('.timeline-archive__line');
      var nodes = Array.prototype.slice.call(section.querySelectorAll('.timeline-archive__node'));
      var horizontalMQ = window.matchMedia('(min-width: 768px)');
      var ticking = false;

      function isHorizontal() {
        return section.classList.contains('timeline-archive--horizontal') && horizontalMQ.matches;
      }

      function clamp01(n) {
        if (n < 0) return 0;
        if (n > 1) return 1;
        return n;
      }

      function updateFill() {
        ticking = false;
        var rect = track.getBoundingClientRect();
        var progress;
        var fillPx;

        if (isHorizontal()) {
          /* Line spans the full scrollable content width */
          if (line) line.style.width = track.scrollWidth + 'px';
          var maxScroll = track.scrollWidth - track.clientWidth;
          progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          progress = clamp01(progress);
          fill.style.height = '100%';
          fill.style.width = progress * 100 + '%';
          fillPx = progress * track.scrollWidth;
        } else {
          if (line) line.style.width = '';
          fill.style.width = '';
          var viewport = window.innerHeight || document.documentElement.clientHeight;
          var reference = viewport * 0.5; /* fill reaches a point as it passes mid-viewport */
          progress = clamp01((reference - rect.top) / rect.height);
          fill.style.height = progress * 100 + '%';
          fillPx = progress * rect.height;
        }

        /* Drive each node's ring so the line appears to split around the circle */
        for (var i = 0; i < nodes.length; i++) {
          var nr = nodes[i].getBoundingClientRect();
          var ringProgress;
          if (isHorizontal()) {
            var leftX = nr.left - rect.left + track.scrollLeft;
            ringProgress = clamp01((fillPx - leftX) / (nr.width || 1));
          } else {
            var topY = nr.top - rect.top;
            ringProgress = clamp01((fillPx - topY) / (nr.height || 1));
          }
          nodes[i].style.setProperty('--ring-progress', ringProgress.toFixed(3));
        }
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateFill);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      track.addEventListener('scroll', onScroll, { passive: true });
      if (horizontalMQ.addEventListener) {
        horizontalMQ.addEventListener('change', onScroll);
      }
      updateFill();
    }
  });
})();
